export enum ChangeStatusEnum {
  added = 'added',
  modified = 'modified',
  deleted = 'deleted',
  none = 'none'
}
